import {
  getIntegrationsAction,
  getIntegrationsFailAction,
  getIntegrationsSuccessAction,
} from '../integrations.actions';
import { IntegrationsDetails } from '../interfaces';
import { createReducer, Action, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export interface State extends EntityState<IntegrationsDetails> {
  isLoading: boolean;
}

export function selectId(a: IntegrationsDetails): string {
  return a.id;
}

export function sortByName(
  a: IntegrationsDetails,
  b: IntegrationsDetails,
): number {
  return a.id.localeCompare(b.id);
}

export const adapter: EntityAdapter<IntegrationsDetails> = createEntityAdapter<
  IntegrationsDetails
>({
  selectId,
  sortComparer: sortByName,
});

export const initialState: State = adapter.getInitialState({
  isLoading: false,
});

const integrationsReducer = createReducer(
  initialState,
  on(getIntegrationsAction, (state) => ({ ...state, isLoading: true })),
  on(getIntegrationsSuccessAction, (state, action) => ({
    ...state,
    ...adapter.setAll(action.integrations, state),
    isLoading: false,
  })),
  on(getIntegrationsFailAction, (state) => ({ ...state, isLoading: false })),
);

export function reducer(state: State | undefined, action: Action) {
  return integrationsReducer(state, action);
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
